import(/* webpackMode: "eager" */ "/vercel/path0/src/app/skaiciuokle/[insurance]/error.jsx");
